module.exports = __webpack_public_path__ + "media/SellHome.f9de3c6d.svg";